import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const TitlePositioner = styled.div<{ positions: Record<string, number> }>`
    position: absolute;
    z-index: 1;
    top: ${({ positions: { top } }) => top && `${top}px`};
    right: ${({ positions: { right } }) => right && `${right}px`};
    bottom: ${({ positions: { bottom } }) => bottom && `${bottom}px`};
    left: ${({ positions: { left } }) => left && `${left}px`};
`;

export const TitleText = styled.div`
    ${setFontVariant("input2", colorsPalettes.carbon[250])};
    margin-right: 4px;
`;
